document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll("[data-video-carousel]");

  carousels.forEach((carousel) => {
    const viewport = carousel.querySelector(".embla__viewport");

    const embla = EmblaCarousel(viewport, {
      loop: true,
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps"
    });

    embla.on("init", () => {
        embla.scrollTo(2, true);
        playCurrentVideo();
    });
    const prevBtn = carousel.querySelector(".embla__prev");
    const nextBtn = carousel.querySelector(".embla__next");

    if (prevBtn) {
      prevBtn.addEventListener("click", () => embla.scrollPrev());
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => embla.scrollNext());
    }

    const slides = [...carousel.querySelectorAll(".embla__slide")];

    function stopAllVideos() {
      slides.forEach((slide) => {
        const video = slide.querySelector("video");

        if (!video) return;

        video.pause();
        video.currentTime = 0;
      });
    }

    function playCurrentVideo() {
      stopAllVideos();

      let index = embla.selectedScrollSnap() + 2;

        if (index >= slides.length) {
            index = index % slides.length;
        }

        const currentSlide = slides[index];

      if (!currentSlide) return;

      const video = currentSlide.querySelector("video");

      if (!video) return;

      video.play().catch(() => {});
    }

    embla.on("select", playCurrentVideo);

    embla.on("init", playCurrentVideo);

    embla.scrollTo(2, true);

    setTimeout(() => {
    playCurrentVideo();
    }, 100);

    carousel.querySelectorAll(".video-card__mute").forEach((button) => {

      const video = button
        .closest(".video-card")
        .querySelector("video");

      if (!video) return;

      button.addEventListener("click", () => {

        video.muted = !video.muted;

        button.classList.toggle("is-muted", video.muted);

        button.innerHTML = video.muted
          ? `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 9V15H9L14 20V4L9 9H5Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>
            <path d="M23 9L17 15"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"/>
            <path d="M17 9L23 15"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"/>
          </svg>
        `
          : `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 9V15H9L14 20V4L9 9H5Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>
            <path d="M18 9C19.2 10.2 20 11.8 20 13.5C20 15.2 19.2 16.8 18 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"/>
          </svg>
        `;

      });

    });

    window.addEventListener("resize", () => {
      embla.reInit();
    });

  });

});